export { icons } from './lib/config';
export * from './lib/icon.module';
export * from './lib/icon-registry.service';
export * from './lib/provideIconConfig';
